module.exports = __webpack_public_path__ + "static/img/8.9e9e577.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/zh/8.png
// module id = /SXa
// module chunks = 0